export interface NavItem {
  path: string
  label: string
  icon: string // emoji for now; replace with SVG in later phase
}

export const navItems: NavItem[] = [
  { path: '/', label: 'Home', icon: '🏠' },
  { path: '/money', label: 'Money', icon: '💵' },
  { path: '/prints', label: 'Prints', icon: '🖨️' },
  { path: '/prints/filament', label: 'Filament', icon: '🧵' },
]
